import { html } from '@webtides/element-js';
import FormField from '../form-field/form-field.class';
import InputEvents from '../events/InputEvents';
import style from './radio-field.css';

export default class RadioField extends FormField {
    constructor(options) {
        super({ shadowRender: false, styles: [style], ...options });
    }

    properties() {
        return {
            ...super.properties(),
            checked: false,
        };
    }

    connected() {
        this.setAttribute('checked', this.checked === true ? 'true' : 'false');
    }

    watch() {
        return {
            checked: checked => {
                this.setAttribute('checked', checked ? 'true' : 'false');
                this.dispatch(InputEvents.INPUT_CHANGE, this.$refs.input.value, true);
            },
        };
    }

    events() {
        return {
            input: {
                change: () => {
                    this.checked = true;
                    // radio/checkbox input controls will only trigger change events when checked, but not when unchecked...
                    // so we need to uncheck all other radio-controls with the same name by hand
                    const radioControls = document.querySelectorAll(`radio-field[name="${this.name}"]`);
                    radioControls.forEach(radioControl => {
                        if (radioControl !== this) {
                            radioControl.checked = false;
                        }
                    });
                },
            },
        };
    }

    fieldTemplate() {
        return html`
            <label for="input-${this.uuid}">
                <input
                    ref="input"
                    type="radio"
                    id="input-${this.uuid}"
                    aria-describedby="${this.uuid}-help"
                    value="${this.value}"
                    name="${this.name}"
                    ?disabled="${this.disabled}"
                    ?checked="${this.checked}"
                    ?required="${this.required}"
                />
                <div class="checked-indicator">
                    <div class="checked"></div>
                </div>
                <div class="label">${this.label}</div>
            </label>
        `;
    }
}
